import validation from '../../Gull/Framework/validation.js';

const conditioneleVragen = {
	/**
	 * Initializes the conditioneleVragen by hiding specified containers and removing validation requirements from selects and inputs.
	 *
	 * @returns {void}
	 */
	init: function () {
		conditioneleVragen.initEvents();

		const containers = document.querySelectorAll('[data-conditions]');
		const selects = document.querySelectorAll('[data-conditions] select');
		const inputs = document.querySelectorAll('[data-conditions] input');

		containers.forEach((el) => el.classList.add('d-none'));
		containers.forEach((el) => el.classList.remove('d-md-table-row'));
		selects.forEach((el) => validation.removeRequired(el));
		inputs.forEach((el) => validation.removeRequired(el));
	},

	/**
	 * Initializes event listeners for various form-related events such as change, blur, keyup, and form submission.
	 *
	 * @returns {void}
	 */
	initEvents: function () {
		document.addEventListener(
			'change',
			function (event) {
				for (var target = event.target; target && target != this; target = target.parentNode) {
					if (target.matches('[data-actie-werkgever-vraag]')) {
						conditioneleVragen.toggle();
						conditioneleVragen.toggleUploads(event);
						break;
					}
				}
			},
			false
		);
	},

	/**
	 * Toggles the visibility of file input fields, removes name attributes for hidden inputs,
	 * and updates a corresponding hidden input field to indicate the presence of visible file inputs.
	 *
	 * @returns {void}
	 */
	toggleUploads: function () {
		var uploadElements = [];

		document.querySelectorAll('.form-actie [data-actie-werkgever-vraag].d-none input[type=file]').forEach(function (element) {
			const originalName = element.getAttribute('name');
			if (typeof originalName === 'string') {
				element.setAttribute('data-original-name', originalName);
				element.removeAttribute('name');
			}
		});

		document.querySelectorAll('.form-actie  [data-actie-werkgever-vraag]:not(.d-none) input[type=file]').forEach(function (element) {
			const originalName = element.getAttribute('data-original-name');
			if (typeof originalName === 'string') {
				element.setAttribute('name', originalName);
				uploadElements.push(element);
			}
		});

		var elemenNoFileUploadInput = document.querySelector('[name=noFileUpload]');
		if (elemenNoFileUploadInput !== null) {
			if (uploadElements.length > 0) {
				elemenNoFileUploadInput.value = 0;
			} else {
				elemenNoFileUploadInput.value = 1;
			}
		}
	},

	/**
	 * Toggles the visibility of elements based on conditional questions and adjusts validation requirements accordingly.
	 *
	 * @returns {void}
	 */
	toggle: function () {
		setTimeout(function () {
			document.querySelectorAll('[data-conditions]').forEach(function (element) {
				const visibilityConditions = conditioneleVragen.check(element);
				if (visibilityConditions) {
					element.classList.remove('d-none');
					element.classList.add('d-md-table-row');
					element.querySelectorAll('select,input:not([type=hidden]:not([type=radio])').forEach((el) => validation.addRequired(el));
				} else {
					element.classList.add('d-none');
					element.classList.remove('d-md-table-row');
					element.querySelectorAll('select,input').forEach((el) => validation.removeRequired(el));
					element.querySelectorAll('input[type=radio]').forEach((radioButton) => (radioButton.checked = false));
					element.querySelectorAll('[data-actie-werkgever-antwoord]').forEach((antwoord) => (antwoord.value = ''));
				}
			});
		}, 100);
	},

	/**
	 * Checks the visibility conditions of an element based on preceeding questions' values.
	 *
	 * @param {HTMLElement} el - The element to check conditions for.
	 *
	 * @returns {boolean} - True if conditions are met, otherwise false.
	 */
	check: function (el) {
		let conditionsMet = true;
		let currentQuestionConditions = JSON.parse(el.dataset.conditions);
		Object.keys(currentQuestionConditions).forEach((id) => {
			let targetValue = document.getElementById(id).value?.toLowerCase();
			let conditionValues = currentQuestionConditions[id];
			if (typeof conditionValues == 'string') {
				conditionValues = [conditionValues];
			}
			let conditionValuesLowercase = conditionValues.map((item) => item.toLowerCase());
			if (!conditionValuesLowercase.includes(targetValue)) {
				conditionsMet = false;
			}
		});

		return conditionsMet;
	},
};

export default conditioneleVragen;
